import React from 'react'

import { cn } from '@/utils/common'

const BUTTON_BASE_CLASSES = 'inline-flex bg-white border-none cursor-pointer'

export interface ToolbarButtonProps {
  icon: React.ReactNode
  onClick: () => void
  isActive?: boolean
  disabled?: boolean
  ariaLabel: string
  title: string
}

export const ToolbarButton: React.FC<ToolbarButtonProps> = ({
  icon,
  onClick,
  isActive = false,
  disabled = false,
  ariaLabel,
  title,
}) => {
  return (
    <button
      type="button"
      onMouseDown={(e) => {
        e.preventDefault()
        onClick()
      }}
      disabled={disabled}
      className={cn(
        BUTTON_BASE_CLASSES,
        isActive ? 'text-black' : 'text-gray-300 hover:text-black'
      )}
      aria-label={ariaLabel}
      title={title}
    >
      {icon}
    </button>
  )
}
